import Flex from './Flex'
import Loading from './Loading'
import StyledPopup, { MyPopup } from './StyledPopup'
import { SvgIcon, BaseSvgButton, SvgButton } from './SvgIcon'
import Swiper from './Swiper'
export const gtmId = 'GTM-T9V5RGS'

export { Flex, Loading, StyledPopup, SvgIcon, BaseSvgButton, SvgButton, Swiper }
